import React from "react";
import { useNavigate } from "react-router-dom";
import SupportIcon from "../../../assets/Dashboard/NeedSupport.svg";
import "./SupportSection.css"; // Make sure this line is here

const SupportSection = () => {
  const navigate = useNavigate();

  const handleContactUsClick = () => {
    navigate("/contact");
  };

  return (
    <div className="smai-support-section">
      <div className="smai-support-icon">
        <img src={SupportIcon} alt="Support" />
      </div>
      <h3 className="smai-support-title">Need Help?</h3>
      <p className="smai-support-text">
        Have a question?
        <br /> We’d love to hear from you.
      </p>
      <button className="smai-support-button" onClick={handleContactUsClick}>
        Contact Us
      </button>
    </div>
  );
};

export default SupportSection;
